/* -------------------------------------------------------------------------- */
/*                                Steps styles                */
/* -------------------------------------------------------------------------- */

@import './bq-steps.variables';

:host {
  @apply box-border inline-flex;
}

:host([orientation='vertical']) {
  @apply flex bs-full;
}
